import type { MonthGroup } from '@/cmsBackend/transformers/types/featureAnnouncement';

/** Appends a month group or merges announcements when the same month key already exists. */
export function mergeMonthGroupIntoList(prev: MonthGroup[], incoming: MonthGroup): MonthGroup[] {
  const existingIndex = prev.findIndex((group) => group.key === incoming.key);
  if (existingIndex === -1) {
    return [...prev, incoming];
  }

  const existing = prev[existingIndex];
  const seenMajorIds = new Set(existing.majorAnnouncements.map((card) => card.id));
  const mergedMajorAnnouncements = [
    ...existing.majorAnnouncements,
    ...incoming.majorAnnouncements.filter((card) => !seenMajorIds.has(card.id)),
  ];
  const seenMinorIds = new Set(existing.minorAnnouncements.map((card) => card.id));
  const mergedMinorAnnouncements = [
    ...existing.minorAnnouncements,
    ...incoming.minorAnnouncements.filter((card) => !seenMinorIds.has(card.id)),
  ];

  const merged: MonthGroup = {
    ...existing,
    majorAnnouncements: mergedMajorAnnouncements,
    minorAnnouncements: mergedMinorAnnouncements,
    count: mergedMajorAnnouncements.length + mergedMinorAnnouncements.length,
  };

  return prev.map((group, index) => (index === existingIndex ? merged : group));
}
